import { Button } from '@eventbrite/eds-button';
import { Icon } from '@eventbrite/eds-icon';
import { MagnifyingGlass } from '@eventbrite/eds-iconography';
import { Modal, ModalType } from '@eventbrite/eds-modal';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import React, { FunctionComponent, useState } from 'react';
import {
    IMAGE_SIZE,
    REBRANDING_IMAGE_SIZE,
} from '../../containers/ticketSelection/constants';
import ImagePreviewModalBody from '../imagePreviewModalBody';
import './TicketImageThumbnail.scss';

export interface TicketImageThumbnailProps {
    isAppRebrandActive?: boolean;
    thumbnailUrl: string;
    fullImageUrl: string;
    title: string | GenericLazyString;
}

const TicketImageThumbnail: FunctionComponent<TicketImageThumbnailProps> = ({
    thumbnailUrl,
    fullImageUrl,
    title,
    isAppRebrandActive = false,
}) => {
    const [isModalShown, setIsModalShown] = useState(false);

    const toggleModalShownState = () => setIsModalShown(!isModalShown);

    const imageSize = isAppRebrandActive ? REBRANDING_IMAGE_SIZE : IMAGE_SIZE;

    return (
        <div
            data-testid="ticket-image-thumbnail"
            className="ticket__image-thumbnail"
        >
            <Button
                style="none"
                onClick={toggleModalShownState}
                data-spec="ticket-image-button"
                role="button"
                aria-label={gettext('Zoom into the image').toString()}
            >
                <div className="ticket__image-overlay">
                    <div className="ticket__image-zoom-icon">
                        <Icon type={<MagnifyingGlass />} />
                    </div>
                </div>
            </Button>

            <img
                width={imageSize}
                height={imageSize}
                src={thumbnailUrl}
                alt={gettext('Ticket variant image').toString()}
            />
            <Modal
                title={title}
                type={ModalType.aperture}
                primaryText={gettext('Return to Checkout')}
                onClose={toggleModalShownState}
                onPrimaryAction={toggleModalShownState}
                isShown={isModalShown}
            >
                <ImagePreviewModalBody imageUrl={fullImageUrl} />
            </Modal>
        </div>
    );
};
export default TicketImageThumbnail;
